import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import { push as Push } from 'redux-first-history';
import { Login as LoginModule } from '@dev/ee-modules';
import { useIntercom } from 'react-use-intercom';
import { ProductCode } from '@dev/ee-api/ee-api-models';
import { local, session } from 'store2';
import { match } from 'ts-pattern';
import { useLocation } from 'react-router-dom';
import {
    getSessionStore,
    LoginUser,
    SessionFailedAuth,
    SessionStartAuth,
    SessionSuccessAuth,
} from '@/store/session/actions';
import { ApplicationState as AppState } from '@/store/index';
import { useMobile } from '@/services/hooks/useMobile';
import { Resend2FACode, ResendActivationEmail } from '@/store/auth/actions';
import { LoginWithDisposableToken, ResetAccountEmail } from '@/store/account/actions';
import { getConfigStore } from '@/store/config/actions';

import { DashboardPaths } from '@/services/dictionaries/Paths';
import { isCustomBranding } from '@/services/Secuirty';
import { DispatchProps, LoginProps } from './LoginInterface';
import { useConfigProductCode } from '@/services/hooks/useConfigProductCode';

const dispatchProps = {
    LoginWithDisposableToken,
    SessionStartAuth,
    SessionFailedAuth,
    SessionSuccessAuth,
    Push,
    LoginUser,
    Resend2FACode,
    ResendActivationEmail,
    ResetAccountEmail,
};

const mapState = (state: AppState, ownProps: LoginProps): LoginProps => ({
    ...ownProps,
    account: state.account,
    products: state.products,
    config: state.config,
});

type Props = LoginProps & DispatchProps;

const Login: FC<Props> = ({ LoginWithDisposableToken, Push, ...restOfProps }: Props): JSX.Element => {
    const { show } = useIntercom() || {};
    const isMobile = useMobile();
    const location = useLocation();
    const { bootedAsChild, isStandalone } = useSelector(getConfigStore);
    const { authorized } = useSelector(getSessionStore);
    const productCode = useConfigProductCode();

    const launchIntercom = () => {
        !isCustomBranding() && show();
    };
    const { t } = useTranslation();
    const setLegacyAccount = (pathNameToRedirect: string) => {
        const ee = globalThis.ee;
        if (ee && authorized) {
            const apiKey = local.get('token') || session.get('token');
            const rememberMe = !!local.get('token');
            const userName = session.get('username');
            return ee?.session?.setAccount(apiKey, rememberMe, `#${pathNameToRedirect}`, userName);
        }
        return Push(pathNameToRedirect);
    };
        
    return (
        <LoginModule
            t={t}
            isMobile={isMobile}
            location={location}
            productCode={productCode}
            launchIntercom={launchIntercom}
            GOOGLEAPIKEY={GOOGLEAPIKEY}
            {...(restOfProps as any)}
            // {...(bootedAsChild && { LoginWithDisposableToken })}
            Push={isStandalone || bootedAsChild ? Push : setLegacyAccount}
        />
    );
};

export default connect<LoginProps, DispatchProps>(mapState, dispatchProps)(Login);
